angular
  .module('ui-ng-calendar-time')
  .factory('calendarTimeFn', function calendarTimeFn(DayOfTheWeekEnum, CalendarWeekTimeBuilder) {
    var convertTimesToUnix = function convertTimesToUnix(times) {
      return _.sortBy(
        _.map(times, function (time) {
          return {
            day: time.day,
            from: time.from.unix(),
            to: time.to.unix(),
            content: time.content,
            bkgColorClass: time.bkgColorClass,
            appId: time.appId
          };
        }),
        'from'
      );
    };

    var convertTimesFromUnix = function convertTimesFromUnix(times) {
      return _.map(_.compact(times), function (time) {
        return new CalendarWeekTimeBuilder({
          from_tm: moment.unix(time.from),
          to_tm: moment.unix(time.to),
          day_of_week: time.day.ordinal,
          content: time.content,
          bkgColorClass: time.bkgColorClass,
          appId: time.appId
        });
      });
    };

    var removeOverlappingTimes = function removeOverlappingTimes(times) {
      var collpaseWasNecessary = false;

      for (var i = times.length - 1; i > 0; i--) {
        if (times[i].from < times[i - 1].to && times[i].day.key !== 'online') {
          collpaseWasNecessary = true;

          times[i - 1].to = Math.max(times[i].to, times[i - 1].to);

          times[i - 1].from = Math.min(times[i].from, times[i - 1].from);

          times[i] = undefined;
        }
      }

      return collpaseWasNecessary;
    };

    var collpaseDay = function collapseDay(times) {
      var collpaseWasNecessary;

      do {
        times = convertTimesToUnix(times);
        collpaseWasNecessary = removeOverlappingTimes(times);
        times = convertTimesFromUnix(times);
      } while (collpaseWasNecessary);

      return times;
    };

    return {
      exportTimeFormat: function exportTime(time) {
        return time.format('HH:mm') + ':00';
      },

      exportDay: function exportDay(day) {
        return day.ordinal;
      },

      findTimesForDay: function findTimesForDay(times, day) {
        var validTimes = _.compact(
          _.filter(times, function (time) {
            return !!time.day;
          })
        );

        return _.filter(validTimes, function (time) {
          return DayOfTheWeekEnum.isEqual(time.day, day);
        });
      },

      findTimeForDay: function findTimeForDay(times, day, hasTime) {
        return _.find(this.findTimesForDay(times, day), function (timeBlock) {
          return hasTime.unix() >= timeBlock.from.unix() && hasTime.unix() <= timeBlock.to.unix();
        });
      },

      doesDayHaveTime: function doesDayHaveTime(times, day, hasTime) {
        return !_.isUndefined(this.findTimeForDay(times, day, hasTime));
      },

      removeTimeFromDay: function removeTimeFromDay(times, day, removeTimeBlock) {
        var rmF = removeTimeBlock.from.unix();
        var rmT = removeTimeBlock.to.unix();
        var addedTimes = [];

        _.each(
          this.findTimesForDay(times, day),
          function (timeBlock) {
            var tbF = timeBlock.from.unix();
            var tbT = timeBlock.to.unix();

            var doesFIntersect = rmF > tbF && rmF < tbT;
            var doesTIntersect = rmT < tbT && rmT > tbF;
            var doesEncompass = rmF <= tbF && rmT >= tbT;

            if (doesEncompass) {
              timeBlock.erase = true;
            } else if (doesFIntersect && doesTIntersect) {
              addedTimes.push(
                new CalendarWeekTimeBuilder({
                  day_of_week: this.exportDay(timeBlock.day),
                  from_tm: this.exportTimeFormat(removeTimeBlock.to),
                  to_tm: this.exportTimeFormat(timeBlock.to)
                })
              );

              timeBlock.to = moment(removeTimeBlock.from);
            } else if (doesFIntersect && rmT > tbT) {
              timeBlock.to = moment(removeTimeBlock.from);
            } else if (doesTIntersect && rmF < tbF) {
              timeBlock.from = moment(removeTimeBlock.to);
            }
          },
          this
        );

        // NOTE times updated
        _.remove(times, function (timeBlock) {
          return timeBlock.erase;
        });

        return times.concat(addedTimes);
      },

      addEmptyTimeOfDay: function addEmptyTimeOfDay(times, firstHour, lastHour) {
        var nextDay = !_.isEmpty(times) ? _.last(times).day.ordinal + 1 : DayOfTheWeekEnum.MO.ordinal;

        if (nextDay > DayOfTheWeekEnum.SA.ordinal) {
          nextDay = DayOfTheWeekEnum.SU.ordinal;
        }

        // NOTE times updated
        times.push(
          new CalendarWeekTimeBuilder({
            from_tm: firstHour,
            to_tm: lastHour,
            day_of_week: nextDay
          })
        );

        return times;
      },

      addTimeOfDay: function addTimeOfDay(times, day, addTimeBlock) {
        // NOTE times updated
        times.push(
          new CalendarWeekTimeBuilder({
            day_of_week: this.exportDay(DayOfTheWeekEnum.get(day)),
            from_tm: this.exportTimeFormat(addTimeBlock.from),
            to_tm: this.exportTimeFormat(addTimeBlock.to)
          })
        );

        return times;
      },

      collapseTimes: function collapseTimes(times) {
        var validTimes = _.compact(
          _.filter(times, function (time) {
            return !!time.day;
          })
        );

        var eachDaysTime = _.groupBy(validTimes, function (time) {
          return time.day.id;
        });

        var collapsedTime = _.reduce(
          eachDaysTime,
          function (collpasedTime, dayTimes) {
            return collpasedTime.concat(collpaseDay(dayTimes));
          },
          []
        );

        return _.sortBy(collapsedTime, function (time) {
          return time.day.ordinal;
        });
      },

      importTimes: function importTimes(times) {
        return _.map(
          times,
          function (time) {
            return this.importTime(time);
          },
          this
        );
      },

      importTime: function importTime(time) {
        return new CalendarWeekTimeBuilder(time);
      },

      exportTimes: function exportTimes(times) {
        return _.map(
          times,
          function (time) {
            return this.exportTime(time);
          },
          this
        );
      },

      exportTime: function exportTime(time) {
        return {
          id: time.id,
          day_of_week: this.exportDay(time.day),
          from_tm: this.exportTimeFormat(time.from),
          to_tm: this.exportTimeFormat(time.to)
        };
      }
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar-time/src/functions/calendar_week_time_functions.js